export const PAGE_PERMISSION = Object.freeze({
  PLATFORM_OVERVIEW: 'platform.overview',
  SCREEN_MONITOR: 'screen.monitor',
  SCREEN_GIS: 'screen.gis',
  SCADA_TEMPLATE: 'scada.template',
  SCADA_BUILDING: 'scada.building',
  SCADA_PREPARATION_WATER: 'scada.preparation_water_quality',
  SCADA_DENTAL_DISINFECTION: 'scada.dental_disinfection',
  MONITOR_DEVICE_REALTIME: 'monitor.device.realtime',
  MONITOR_DEVICE_SCADA: 'monitor.device.scada',
  MONITOR_DEVICE_COMMAND_SEND: 'monitor.device.command_send',
  MONITOR_DEVICE_COMMAND_HISTORY: 'monitor.device.command_history',
  MONITOR_DEVICE_HISTORY_CHART: 'monitor.device.history_chart',
  MONITOR_DEVICE_HISTORY_TABLE: 'monitor.device.history_table',
  MONITOR_DEVICE_ALARM: 'monitor.device.alarm',
  MONITOR_DEVICE_ONLINE_LOG: 'monitor.device.online_log',
  MONITOR_SCHEDULED_TASK: 'monitor.scheduled_task',
  QUALITY_DISINFECTANT_CHANGE: 'quality.disinfectant_change',
  QUALITY_SENSOR_CALIBRATION: 'quality.sensor_calibration',
  QUALITY_DISINFECTION_RECORD: 'quality.disinfection_record',
  ALARM_LATEST: 'alarm.latest',
  ALARM_DEVICE_ONLINE: 'alarm.device_online',
  FAULT_FEEDBACK: 'fault.feedback',
  DATA_HISTORY: 'data.history',
  PROJECT_MANAGE: 'project.manage',
  DEVICE_MANAGE: 'device.manage',
  DEVICE_POINT_TEMPLATE: 'device.point_template',
  DEVICE_FIRMWARE: 'device.firmware',
  // @deprecated 物联网卡充值已永久停用；仅保留旧权限 key 以过滤历史授权。
  IOT_RECHARGE: 'iot.recharge',
  LOG_ACCESS: 'log.access',
  LOG_OPERATION: 'log.operation',
  SYSTEM_ALARM_NOTIFY: 'system.alarm_notify',
})

export const DEPRECATED_PAGE_PERMISSION_KEYS = Object.freeze([
  PAGE_PERMISSION.IOT_RECHARGE,
])

export const PAGE_PERMISSION_KEYS = Object.freeze(
  Object.values(PAGE_PERMISSION).filter(
    (key) => !DEPRECATED_PAGE_PERMISSION_KEYS.includes(key)
  )
)

export const ACTION_PERMISSION = Object.freeze({
  DEVICE_COMMAND_SEND: 'device.command.send',
  DEVICE_FIRMWARE_PUBLISH: 'device.firmware.publish',
  DEVICE_SCHEDULED_TASK_MANAGE: 'device.scheduled_task.manage',
  DEVICE_MAINTENANCE_UPDATE: 'device.maintenance.update',
  DEVICE_ALARM_HANDLE: 'device.alarm.handle',
  DISINFECTION_RECORD_DELETE: 'disinfection.record.delete',
  DISINFECTION_SCHEDULE_MANAGE: 'disinfection.schedule.manage',
})

export const ACTION_PERMISSION_OPTIONS = Object.freeze([
  { value: ACTION_PERMISSION.DEVICE_COMMAND_SEND, label: '命令下发（含刷新、重启）' },
  { value: ACTION_PERMISSION.DEVICE_FIRMWARE_PUBLISH, label: '固件推送' },
  { value: ACTION_PERMISSION.DEVICE_SCHEDULED_TASK_MANAGE, label: '定时任务管理' },
  { value: ACTION_PERMISSION.DEVICE_MAINTENANCE_UPDATE, label: '维护信息修改' },
  { value: ACTION_PERMISSION.DEVICE_ALARM_HANDLE, label: '告警处理' },
  {
    value: ACTION_PERMISSION.DISINFECTION_RECORD_DELETE,
    label: '消毒记录删除',
    uiProfile: 'dental',
  },
  {
    value: ACTION_PERMISSION.DISINFECTION_SCHEDULE_MANAGE,
    label: '消毒排班管理',
    uiProfile: 'dental',
  },
])

// 租户专属操作只在对应管理员的“页面与操作权限”中出现；后端仍会再次校验。
export function actionPermissionOptionsFor(uiProfile) {
  const profile = String(uiProfile || '').trim().toLowerCase()
  return ACTION_PERMISSION_OPTIONS.filter(
    (option) => !option.uiProfile || option.uiProfile === profile
  )
}

export const DEVICE_MONITOR_PERMISSION_KEYS = Object.freeze([
  PAGE_PERMISSION.MONITOR_DEVICE_REALTIME,
  PAGE_PERMISSION.MONITOR_DEVICE_SCADA,
  PAGE_PERMISSION.MONITOR_DEVICE_COMMAND_SEND,
  PAGE_PERMISSION.MONITOR_DEVICE_COMMAND_HISTORY,
  PAGE_PERMISSION.MONITOR_DEVICE_HISTORY_CHART,
  PAGE_PERMISSION.MONITOR_DEVICE_HISTORY_TABLE,
  PAGE_PERMISSION.MONITOR_DEVICE_ALARM,
  PAGE_PERMISSION.MONITOR_DEVICE_ONLINE_LOG,
])

export const PAGE_PERMISSION_TREE = [
  { key: PAGE_PERMISSION.PLATFORM_OVERVIEW, label: '平台概况', disabled: true },
  {
    key: 'group.screen',
    label: '大屏中心',
    children: [
      { key: PAGE_PERMISSION.SCREEN_MONITOR, label: '监控大屏' },
      { key: PAGE_PERMISSION.SCREEN_GIS, label: 'GIS大屏' },
    ],
  },
  {
    key: 'group.scada',
    label: '云组态',
    children: [
      { key: PAGE_PERMISSION.SCADA_TEMPLATE, label: '组态模板库' },
      { key: PAGE_PERMISSION.SCADA_BUILDING, label: '大楼组态' },
      { key: PAGE_PERMISSION.SCADA_PREPARATION_WATER, label: '制剂室水质监测组态' },
      { key: PAGE_PERMISSION.SCADA_DENTAL_DISINFECTION, label: '牙椅组态' },
    ],
  },
  {
    key: 'group.monitor',
    label: '在线监测',
    children: [
      {
        key: 'group.monitor.device',
        label: '设备监测',
        children: [
          { key: PAGE_PERMISSION.MONITOR_DEVICE_REALTIME, label: '实时数据' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_SCADA, label: '云组态' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_COMMAND_SEND, label: '命令下发' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_COMMAND_HISTORY, label: '历史命令' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_HISTORY_CHART, label: '历史图表' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_HISTORY_TABLE, label: '历史表格' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_ALARM, label: '告警记录' },
          { key: PAGE_PERMISSION.MONITOR_DEVICE_ONLINE_LOG, label: '上下线记录' },
        ],
      },
      { key: PAGE_PERMISSION.MONITOR_SCHEDULED_TASK, label: '定时任务' },
    ],
  },
  {
    key: 'group.quality',
    label: '质量控制',
    children: [
      { key: PAGE_PERMISSION.QUALITY_DISINFECTANT_CHANGE, label: '消毒原液更换' },
      { key: PAGE_PERMISSION.QUALITY_SENSOR_CALIBRATION, label: '传感器校准' },
    ],
  },
  { key: PAGE_PERMISSION.QUALITY_DISINFECTION_RECORD, label: '消毒中心' },
  {
    key: 'group.alarm',
    label: '报警中心',
    children: [
      { key: PAGE_PERMISSION.ALARM_LATEST, label: '最新报警' },
      { key: PAGE_PERMISSION.ALARM_DEVICE_ONLINE, label: '设备上下线记录' },
    ],
  },
  { key: PAGE_PERMISSION.FAULT_FEEDBACK, label: '故障反馈' },
  {
    key: 'group.data',
    label: '数据中心',
    children: [{ key: PAGE_PERMISSION.DATA_HISTORY, label: '历史数据' }],
  },
  {
    key: 'group.project',
    label: '项目中心',
    children: [{ key: PAGE_PERMISSION.PROJECT_MANAGE, label: '项目管理' }],
  },
  {
    key: 'group.device',
    label: '设备中心',
    children: [
      { key: PAGE_PERMISSION.DEVICE_MANAGE, label: '设备管理' },
      { key: PAGE_PERMISSION.DEVICE_POINT_TEMPLATE, label: '数据点模板' },
      { key: PAGE_PERMISSION.DEVICE_FIRMWARE, label: '固件管理' },
    ],
  },
  // IOT_RECHARGE 已停用，不再允许新授权。
  {
    key: 'group.log',
    label: '日志管理',
    children: [
      { key: PAGE_PERMISSION.LOG_ACCESS, label: '访问日志' },
      { key: PAGE_PERMISSION.LOG_OPERATION, label: '操作日志' },
    ],
  },
  {
    key: 'group.system',
    label: '系统管理',
    children: [{ key: PAGE_PERMISSION.SYSTEM_ALARM_NOTIFY, label: '告警通知' }],
  },
]

export const BASE_MENU_LIST = [
  {
    path: '/platOverview',
    name: '平台概况',
    iconclass: 'iconfont icon-lifangtilitiduomiantifangkuai',
    permission: PAGE_PERMISSION.PLATFORM_OVERVIEW,
  },
  {
    path: '/glsLargeScreen',
    name: '大屏中心',
    iconclass: 'iconfont icon-ditu-01',
    children: [
      { path: '/largeScreen/monitor', name: '监控大屏', permission: PAGE_PERMISSION.SCREEN_MONITOR },
      { path: '/largeScreen/gis', name: 'GIS大屏', permission: PAGE_PERMISSION.SCREEN_GIS },
    ],
  },
  {
    path: '/cloudComponents',
    name: '云组态',
    iconclass: 'iconfont icon-cloud-service',
    children: [
      { path: '/cloudComponents/templateGallery', name: '组态模板库', permission: PAGE_PERMISSION.SCADA_TEMPLATE },
      { path: '/cloudComponents/buildingLayouts', name: '大楼组态', permission: PAGE_PERMISSION.SCADA_BUILDING },
      {
        path: '/cloudComponents/preparationWaterQualityLayouts',
        name: '制剂室水质监测组态',
        permission: PAGE_PERMISSION.SCADA_PREPARATION_WATER,
      },
      {
        path: '/cloudComponents/dentalDisinfectionLayouts',
        name: '牙椅组态（横屏）',
        permission: PAGE_PERMISSION.SCADA_DENTAL_DISINFECTION,
      },
      {
        path: '/cloudComponents/wuhanPortraitLayouts',
        name: '牙椅组态（竖屏）',
        permission: PAGE_PERMISSION.SCADA_DENTAL_DISINFECTION,
      },
    ],
  },
  {
    path: '/onlineMonitoring',
    name: '在线监测',
    iconclass: 'iconfont icon-zaixianjiance',
    children: [
      {
        path: '/equipmentCenter/equipmentDetails',
        name: '设备监测',
        anyPermissions: DEVICE_MONITOR_PERMISSION_KEYS,
      },
      { path: '/onlineMonitoring/scheduledTask', name: '定时任务', permission: PAGE_PERMISSION.MONITOR_SCHEDULED_TASK },
    ],
  },
  {
    path: '/qualityControl',
    name: '质量控制',
    iconclass: 'el-icon-medal',
    children: [
      { path: '/qualityControl/disinfectantChange', name: '消毒原液更换', permission: PAGE_PERMISSION.QUALITY_DISINFECTANT_CHANGE },
      { path: '/qualityControl/sensorCalibration', name: '传感器校准', permission: PAGE_PERMISSION.QUALITY_SENSOR_CALIBRATION },
    ],
  },
  {
    path: '/alarmCenter',
    name: '报警中心',
    iconclass: 'iconfont icon-baojingzhongxin',
    children: [
      { path: '/alarmCenter/alarmRecord', name: '最新报警', permission: PAGE_PERMISSION.ALARM_LATEST },
      { path: '/alarmCenter/deviceOnlineRecord', name: '设备上下线记录', permission: PAGE_PERMISSION.ALARM_DEVICE_ONLINE },
    ],
  },
  { path: '/faultFeedback', name: '故障反馈', iconclass: 'el-icon-warning-outline', permission: PAGE_PERMISSION.FAULT_FEEDBACK },
  {
    path: '/dataCenter',
    name: '数据中心',
    iconclass: 'el-icon-s-data',
    children: [{ path: '/dataCenter/historyData', name: '历史数据', permission: PAGE_PERMISSION.DATA_HISTORY }],
  },
  {
    path: '/projectCenter',
    name: '项目中心',
    iconclass: 'iconfont icon-fenlei',
    children: [{ path: '/projectCenter/projectManage', name: '项目管理', permission: PAGE_PERMISSION.PROJECT_MANAGE }],
  },
  {
    path: '/equipmentCenter',
    name: '设备中心',
    iconclass: 'iconfont icon-shebei',
    children: [
      { path: '/equipmentCenter/equipmentManage', name: '设备管理', permission: PAGE_PERMISSION.DEVICE_MANAGE },
      { path: '/equipmentCenter/dataPointTemplate', name: '数据点模板', permission: PAGE_PERMISSION.DEVICE_POINT_TEMPLATE },
      { path: '/equipmentCenter/firmwareManage', name: '固件管理', permission: PAGE_PERMISSION.DEVICE_FIRMWARE },
    ],
  },
  // /iotRecharge 已停用，不再生成菜单入口。
  {
    path: '/logManage',
    name: '日志管理',
    iconclass: 'el-icon-document',
    children: [
      { path: '/logManage/accessLog', name: '访问日志', permission: PAGE_PERMISSION.LOG_ACCESS },
      { path: '/logManage/operationLog', name: '操作日志', permission: PAGE_PERMISSION.LOG_OPERATION },
    ],
  },
  {
    path: '/systemManage',
    name: '系统管理',
    iconclass: 'iconfont icon-xitongguanli',
    children: [
      { path: '/systemManage/userManage', name: '用户管理', managerOnly: true },
      { path: '/systemManage/alarmNotify', name: '告警通知', permission: PAGE_PERMISSION.SYSTEM_ALARM_NOTIFY },
    ],
  },
]

export function filterMenus(menuList, pageKeys, manager) {
  const allowed = new Set(pageKeys)
  return menuList.reduce((result, item) => {
    if (item.managerOnly && !manager) return result
    if (item.permission && !manager && !allowed.has(item.permission)) return result
    if (
      item.anyPermissions &&
      !manager &&
      !item.anyPermissions.some((key) => allowed.has(key))
    ) return result

    const next = { ...item }
    if (item.children) {
      next.children = filterMenus(item.children, pageKeys, manager)
      if (next.children.length === 0) return result
    }
    result.push(next)
    return result
  }, [])
}

export function canAccessPermissions(pageKeys, requiredKeys) {
  if (!requiredKeys || requiredKeys.length === 0) return false
  const allowed = new Set(pageKeys)
  return requiredKeys.some((key) => allowed.has(key))
}
